<template>
  <div class="sign-setting">
    <div class="com-Breadcrumb">
      <el-breadcrumb separator=">">
        <el-breadcrumb-item
          ><router-link class="item" to="/viewIndex"
            >首页</router-link
          ></el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ computedCurrentMenuName }}</el-breadcrumb-item>
      </el-breadcrumb>
      <router-link class="r-btn" to="/viewIndex">返回上一步</router-link>
    </div>

    <div class="main-wrap">
      <div class="left-wrap">
        <apply-menu-tree
          :currentMenuName.sync="currentMenuName"
          :menus="switchMenus"
          :style="{ height: '100%' }"
        />
      </div>
      <div class="right-wrap">
        <route-name
          v-if="
            currentMenuName !== '账户管理' && currentMenuName !== '常用签署方'
          "
          :propsRouteName="computedCurrentMenuName"
          :style="{
            fontSize: '16px',
            lineHeight: '36px',
            backgroundColor: '#fff',
            fontWeight: '600',
            borderBottom: 'solid 1px #E5E5E5',
            paddingTop: '15px',
          }"
        />
        <nuxt-child />
      </div>
    </div>
  </div>
</template>

<script>
import PublishSign from "../components/publish-sign/index";
import ApplyMenuTree from "@/components/apply-menu-tree";
import RouteName from "@/components/route-name";
export default {
  name: "index",
  components: { PublishSign, ApplyMenuTree, RouteName },
  head () {
    return {
      title: "账户中心"
    };
  },
  data () {
    return {
      entMenus: [
        // 企业账户
        {
          id: "/signSettings/accountInfo",
          label: "账户管理",
          nodeIcon: "icon-tree icon-zh",
          route: {
            path: "/signSettings/accountInfo"
          }
          // href: {
          //   path: this.globalConfig.domain.accountWeb + '/profile',
          //   target: 'blank'
          // }
        },
        {
          id: "/signSettings/signers",
          label: "常用签署方",
          nodeIcon: "icon-tree icon-qsr",
          route: {
            path: "/signSettings/signers"
          }
        },
        {
          id: "/signSettings/costStatistics",
          label: "消费统计",
          nodeIcon: "icon-tree icon-tj",
          route: {
            path: "/signSettings/costStatistics"
          }
        },
        // {
        //   id: "/signSettings/digital",
        //   label: "数字证书授权",
        //   nodeIcon: "icon-tree icon-tpl10",
        //   route: {
        //     path: "/signSettings/digital"
        //   }
        // },
        {
          id: "/signSettings/signMerge",
          label: "签署设置",
          nodeIcon: "icon-tree icon-tpl3",
          route: {
            path: "/signSettings/signMerge"
          }
        }
      ],
      personMenus: [
        // 集团账户
        {
          id: "/signSettings/accountInfo",
          label: "账户管理",
          nodeIcon: "icon-tree icon-zh",
          route: {
            path: "/signSettings/accountInfo"
          }
        },
        {
          id: "/signSettings/signers",
          label: "常用签署方",
          nodeIcon: "icon-tree icon-qsr",
          route: {
            path: "/signSettings/signers"
          }
        },
        {
          id: "/signSettings/costStatistics",
          label: "消费统计",
          nodeIcon: "icon-tree icon-tj",
          route: {
            path: "/signSettings/costStatistics"
          }
        }
        // {
        //   id: '/signSettings/personSet',
        //   label: '签章管理',
        //   route:{
        //     path: '/signSettings/personSet'
        //   }
        // }
      ],
      corpMenus: [
        // 个人账户
        {
          id: "/signSettings/signers",
          label: "常用签署方",
          nodeIcon: "icon-tree icon-qsr",
          route: {
            path: "/signSettings/signers"
          }
        }
        // {
        //   id: '/signSettings/corpSet',
        //   label: '签章管理',
        //   route:{
        //     path: '/signSettings/corpSet'
        //   }
        // }
      ],
      currentMenuName: "", // 当前匹配的菜单名称，用于传递给routeName组件
      showAccountInfo: false
    };
  },
  computed: {
    computedCurrentMenuName () {
      return this.currentMenuName;
    },
    currentAuthUser () {
      return this.$store.getters.currentAuthUser || {};
    },
    switchMenus () {
      if (this.currentAuthUser.userType == 0) {
        return this.personMenus;
      } else if (this.currentAuthUser.userType == 1 || this.currentAuthUser.corpId) {
        return this.entMenus;
      } else if (
        this.currentAuthUser.superFlag == 0 ||
        this.currentAuthUser.superFlag == 1
      ) {
        return this.corpMenus;
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import (less) "../assets/style/icon.css";
.main-wrap {
  height: calc(100vh - 230px);
  .left-wrap {
    height: 100%;
    float: left;
    width: 200px;
    background-color: #ffffff;
    /deep/ .publish {
      padding: 15px 0;
      text-align: left;
      border-bottom: solid 1px #e5e5e5;
      .upload-file {
        width: 80%;
        margin-left: 10%;
        input[type="file"] {
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
        }
        .el-button {
          width: 100%;
        }
      }
      .tpl {
        width: 80%;
        margin-left: 10%;
        margin-bottom: 0;
      }
    }
  }
  .right-wrap {
    margin-left: 215px;
    height: 100%;
    background-color: #ffffff;
    overflow-y: auto;
    .table-wrap {
      padding: 0 16px;
    }
    /deep/.row {
      padding: 15px;
      height: 62px;
      min-height: 62px;
    }
    /deep/.data-list {
      height: calc(100vh - 296px);
      width: inherit;
      margin: 0 15px;
      border: 1px solid #cdcdcd;
      overflow-y: auto;
    }
    /deep/.go-style {
      top: 18px;
    }
    /deep/.pageation {
      position: relative;
    }
  }
}
.sign-setting {
  .header {
    margin-bottom: 0;
    padding-bottom: 10px;
  }
  .menu {
    overflow: hidden;
    margin-top: 10px;
    .nav-bar {
      width: 100%;
      .nav-item {
        font-size: 15px;
        color: #666666;
        margin-right: 40px;
        .nuxt-link {
          vertical-align: middle;
        }
      }
      .nav-item:before {
        content: "";
        display: inline-block;
        width: 2px;
        height: 18px;
        background: #ffffff;
        vertical-align: middle;
        margin-right: 6px;
      }
      .nav-item.active:before {
        background: #ec1c1c;
      }
      .nav-item.active {
        .nuxt-link {
          color: #ec1c1c;
        }
        color: #ec1c1c;
      }
    }
  }
}

/deep/ .el-tree {
  .el-tree-node.is-checked {
    .icon-zh {
      .icon-zh-on();
    }
    .icon-tj {
      .icon-tj-on();
    }
    .icon-mm {
      .icon-mm-on();
    }
    .icon-sqr {
      .icon-sqr-on();
    }
    .icon-qsr {
      .icon-qsr-on();
    }
  }
  .icon-tree {
    width: 15px;
    height: 15px;
    margin-right: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// pages/signSettings.vue